module.exports = __webpack_public_path__ + "img/bg2.eb6995ab.png";